import { useState } from 'react'
import { useAuth } from '../../Providers/AuthProvider'
import SendAddressCard from './Components/SendAddressCard'
import InvoiceDataCard from './Components/InvoiceDataCard'
import DeliveryCard from './Components/DeliveryCard'
import PaymentCard from './Components/PaymentCard'
import ErrorBoundary from '../../Components/ErrorBoundary/ErrorBoundary'
import { FiShoppingCart } from 'react-icons/fi'
import { useLocation, useNavigate } from 'react-router-dom'
import { MdArrowBackIosNew } from 'react-icons/md'
import { SelectBox, TextBox } from 'devextreme-react'
import { useSavedBaskets } from '../../Providers/SavedBasketsProvider'
import { toast } from 'react-toastify';
import { useCart } from '../../Providers/CartProvider'
import YesNoCancelMessageModal from '../../Components/Components/Modals/YesNoCancelMessageModal'
import useAddProductsToSavedBasketFromOrder from '../../Components/BasketPage/Hooks/useAddProductsToSavedBasketFromOrder'
import LoadingSpinner from '../../Components/Components/LoadingSpinner'
import SingleOrderItems from './Components/SingleOrderItems'
import { useParams } from '../../Providers/ParamsProvider'
import { reverseDate } from '../../Helpers/ValidatorHelper'

const OrderIndex = () => {
    const location = useLocation()
    const { selectedOrderDetails } = location.state || {}
    const { authState } = useAuth()
    const [selectedItems, setSelectedItems] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const { savedBaskets, handleGetSavedBasket, handleSaveBasketFromOrder } = useSavedBaskets()
    const [selectedBasket, setSelectedBasket] = useState(null)
    const { handleAddProductsToSavedBasketFromOrder } = useAddProductsToSavedBasketFromOrder()
    const [showSaveBasketForm, setShowSaveBasketForm] = useState(false)
    const [basketName, setBasketName] = useState('')
    const { deleteAllItems, cartItems, addProductsToBasket } = useCart()
    const [showOrderSelectedModal, setShowOrderSelectedModal] = useState(false)
    const [showOrderAgainModal, setShowOrderAgainModal] = useState(false)
    const [isLoadingBasket, setIsLoadingBasket] = useState(false)
    const { isMobile } = useParams()

    const [showValidationError, setShowValidationError] = useState(false)
    const nameColor = showValidationError ? '#fc1c41' : 'black'


    const handleSelectBasket = (e) => {
        setSelectedBasket(e)
    }

    const handleAddProductsToSavedBasketFunc = async () => {
        if (!selectedBasket) {
            toast.warning('Proszę wybrać szybkokoszyk')
            return
        }
        if (selectedItems.length === 0) {
            toast.warning('Proszę wybrać produkty do dodania')
            return
        }
        await handleAddProductsToSavedBasketFromOrder(selectedBasket.basketId, selectedItems)
    }

    const handleOrderSelectedItems = () => {
        if (selectedItems.length === 0) {
            toast.warning('Proszę wybrać produkty!')
            return
        }
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        if (cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowOrderSelectedModal(true)
        }
        else {
            handleOrderSelectedModalResponse('No')
        }
    }

    const handleOrderSelectedModalResponse = async (answer) => {
        if (answer == 'Cancel') {
            setShowOrderSelectedModal(false)
            return
        }
        setIsLoadingBasket(true)
        const formatedItems = selectedItems.map(item => ({
            ...item,
            qty: item.qtyStock
        }))
        const res = await addProductsToBasket(formatedItems, answer === 'Yes' ? true : false)
        setShowOrderSelectedModal(false)
        setIsLoadingBasket(false)
        if (!res) {
            toast.error('Błąd podczas dodawania produktów do koszyka')
            return
        }
        navigate('/Cart')
    }

    const handleOrderAgainModalResponse = async (answer) => {
        if (answer == 'Cancel') {
            setShowOrderAgainModal(false)
            return
        }
        setIsLoadingBasket(true)
        const formatedItems = selectedOrderDetails.products.map(item => ({
            ...item,
            qty: item.qtyStock
        }))
        const res = await addProductsToBasket(formatedItems, answer === 'Yes' ? true : false)
        setShowOrderAgainModal(false)
        setIsLoadingBasket(false)
        if (!res) {
            toast.error('Błąd podczas dodawania produktów do koszyka')
            return
        }
        navigate('/Cart')
    }

    const handleSelectUnSelectAllItems = (items, isChecked) => {
        if (isChecked) {
            setSelectedItems(items)
        }
        else {
            setSelectedItems([])
        }
    }

    const handleCheckUncheckItem = (item, isChecked) => {
        if (isChecked) {
            setSelectedItems(prev => [...prev, item])
        }
        else {
            setSelectedItems(prev => prev.filter(p => p.index !== item.index))
        }
    }

    const handleCreateSaveBasket = async () => {
        if (validData()) {
            if (await handleSaveBasketFromOrder(selectedItems, basketName)) {
                toast.success('Zapisano koszyk')
                handleGetSavedBasket()
            }
            setShowSaveBasketForm(false)
        }
    }

    const validData = () => {
        let result = true
        if (selectedItems.length === 0) {
            toast.warning('Proszę wybrać produkty')
            result = false
        }
        if (basketName === null || basketName === undefined || basketName === '' || basketName.trim() === '') {
            setShowValidationError(true)
            result = false
        }
        return result
    }

    const handleOrderAgain = () => {
        if (!authState.user) {
            toast.warning('Prosze się zalogować')
            return
        }
        if (!authState.custId) {
            toast.warning('Brak wybranego kontrahenta')
            return
        }
        if (cartItems.basketItems && cartItems.basketItems.length > 0) {
            setShowOrderAgainModal(true)
        }
        else {
            handleOrderAgainModalResponse('No')
        }
    }

    if (isLoadingBasket) {
        return <LoadingSpinner loadingText="Wczytywanie koszyka..." />
    }
    return (
        <>
            <ErrorBoundary>
                <div className="container-fluid-with-paddings">
                    <div className="row mt-3 mb-3">
                        <div className="col-12 col-lg">
                            <b style={{ fontSize: '30px' }}>Zamówienie {selectedOrderDetails.ordersNumber + "/" + selectedOrderDetails.siteId + " z " + reverseDate(selectedOrderDetails.ordersDate.substring(0, selectedOrderDetails.ordersDate.indexOf('T')))}</b>
                        </div>
                        <div className="col d-flex justify-content-end">
                            <div className='action-button' onClick={handleOrderAgain}>
                                <span className='me-2'>Zamów ponownie</span>
                                <FiShoppingCart className='action-button-icon ' size={20} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg">
                            <div className='main-container-holder'>
                                <SendAddressCard sendAddress={selectedOrderDetails} />
                            </div>
                        </div>
                        <div className="col mt-3 mt-lg-0">
                            <div className='main-container-holder'>
                                <InvoiceDataCard invoiceData={selectedOrderDetails} />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3 mb-3">
                        <div className="col-12 col-lg">
                            <div className='main-container-holder'>
                                <DeliveryCard order={selectedOrderDetails} />
                            </div>
                        </div>
                        <div className="col mt-3 mt-lg-0">
                            <div className='main-container-holder'>
                                <PaymentCard order={selectedOrderDetails} />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className='main-container-holder'>
                                <SingleOrderItems
                                    items={selectedOrderDetails.products}
                                    isLoading={isLoading}
                                    handleSelectUnSelectAllItems={handleSelectUnSelectAllItems}
                                    handleCheckUncheckItem={handleCheckUncheckItem}
                                />
                            </div>
                        </div>
                    </div>
                    {isMobile ? <><div className={`d-flex flex-column`}>
                        <button className='btn-app-primary mb-2' onClick={() => { setShowSaveBasketForm(prev => !prev) }}>Utwórz nowy szybkokoszyk</button>
                        <button className="btn-app-secondary mb-2" onClick={handleOrderSelectedItems}> Zamów zaznaczone </button>
                        {showSaveBasketForm && (
                            <div className='d-flex' style={{ marginTop: '-5px' }}>
                                <TextBox
                                    placeholder={'Nazwa koszyka'}
                                    showClearButton={true}
                                    width={'30%'}
                                    value={basketName}
                                    onValueChanged={(e) => setBasketName(e.value)}
                                    style={{ borderColor: nameColor }}
                                />
                                <button type="button" className="btn btn-outline-success ms-2 me-2" onClick={() => handleCreateSaveBasket()}>Zapisz</button>
                                <button type="button" className="btn btn-outline-danger" onClick={() => { setShowSaveBasketForm(false) }}>Anuluj</button>
                            </div>
                        )}
                        <div className='favorite-products-add-to-existing-basket-holder d-flex d-md-flex'>
                            <span className='mb-2'>Dodaj do istniejącego szybko koszyka</span>
                            <SelectBox
                                dataSource={savedBaskets}
                                placeholder="Wybierz koszyk"
                                displayExpr={'name'}
                                showClearButton={false}
                                className="cart-page-select-box"
                                noDataText='Brak zapisanych koszyków'
                                onValueChange={(e) => handleSelectBasket(e)}
                            />
                            <button className="btn-app-secondary mt-2" onClick={handleAddProductsToSavedBasketFunc}> Wybierz </button>
                        </div>
                    </div>
                        <div className="col d-flex align-items-center justify-content-start element-pointer mt-2" onClick={() => navigate(-1)}>
                            <MdArrowBackIosNew size={25} />
                            <span>Wróć</span>
                        </div>
                    </> : <>
                        <div className="row">
                            <div className={`d-flex align-items-center `}>
                                <div className="col-auto">
                                    <button className='btn-app-secondary me-3' onClick={() => { setShowSaveBasketForm(prev => !prev) }}>Utwórz nowy szybkokoszyk</button>
                                </div>
                                <div className="col-auto ms-3 ms-md-0 mb-3 mt-3 mt-sm-0 mb-sm-0">
                                    <button className="btn-app-secondary" onClick={handleOrderSelectedItems}> Zamów zaznaczone </button>
                                </div>
                                <div className="col"></div>
                                <div className="col">
                                    <div className="d-flex flex-column align-items-end mt-2 mt-md-0">
                                        <span>Dodaj do istniejącego szybko koszyka</span>
                                        <div className='d-flex align-items-center mt-1'>
                                            <SelectBox
                                                dataSource={savedBaskets}
                                                placeholder="Wybierz koszyk"
                                                displayExpr={'name'}
                                                showClearButton={false}
                                                className="cart-page-select-box"
                                                noDataText='Brak zapisanych koszyków'
                                                onValueChange={(e) => handleSelectBasket(e)}
                                            />
                                            <button className="btn-app-secondary ms-2" onClick={handleAddProductsToSavedBasketFunc}> Wybierz </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {showSaveBasketForm && (
                                <div className='d-flex' style={{ marginTop: '-5px' }}>
                                    <TextBox
                                        placeholder={'Nazwa koszyka'}
                                        showClearButton={true}
                                        width={'30%'}
                                        value={basketName}
                                        onValueChanged={(e) => setBasketName(e.value)}
                                        style={{ borderColor: nameColor }}
                                    />
                                    <button type="button" className="btn btn-outline-success ms-2 me-2" onClick={() => handleCreateSaveBasket()}>Zapisz</button>
                                    <button type="button" className="btn btn-outline-danger" onClick={() => { setShowSaveBasketForm(false) }}>Anuluj</button>
                                </div>
                            )}
                        </div>
                        <div className="col d-flex align-items-center justify-content-start element-pointer mb-5" onClick={() => navigate(-1)}>
                            <MdArrowBackIosNew size={25} />
                            <span>Wróć</span>
                        </div>
                    </>
                    }

                    <YesNoCancelMessageModal
                        show={showOrderSelectedModal}
                        onHide={handleOrderSelectedModalResponse}
                        title={'Pytanie'}
                        message={'Twój koszyk zawiera już pozycje, co chcesz zrobić z zaznaczonymi pozycjami, które dodajesz do koszyka?'}
                        yesText='Nadpisz koszyk'
                        noText='Dopisz do koszyka'
                    />
                    <YesNoCancelMessageModal
                        show={showOrderAgainModal}
                        onHide={handleOrderAgainModalResponse}
                        title={'Pytanie'}
                        message={'Twój koszyk zawiera już pozycje, co chcesz zrobić z produktami, które dodajesz do koszyka?'}
                        yesText='Nadpisz koszyk'
                        noText='Dopisz do koszyka'
                    />
                </div>
            </ErrorBoundary>
        </>
    )
}

export default OrderIndex